import { Skeleton } from "@mui/material";
import { useMemo } from "react";
import * as Styled from "./ProgressBarList.styled";
import { BodyTextM } from "./Typography";

export type ProgressBarListRow = {
    id: number;
    label: string;
    value: number;
};

export type ProgressBarListProps = {
    rows?: ProgressBarListRow[];
    isLoading?: boolean;
    loadingRowsCount?: number;
    wrapperComponent?: React.ElementType;
};

export const ProgressBarList = ({
    rows,
    isLoading,
    loadingRowsCount = 5,
    wrapperComponent: Wrapper = Styled.ProgressBarListPaper,
}: ProgressBarListProps) => {
    // Sort rows by id to ensure consistent order  CON = 1, BAL = 2, GROW = 3
    const sortedRows = useMemo(() => rows?.slice().sort((a, b) => a.id - b.id), [rows]);

    return (
        <Wrapper>
            {sortedRows?.map((row) => (
                <Styled.ProgressBarListItemBox key={row.id.toString()}>
                    <Styled.ProgressBarListItemTitleStack>
                        <BodyTextM>{row.label}</BodyTextM>
                        <Styled.ProgressBarListHeading>{`${row.value} %`}</Styled.ProgressBarListHeading>
                    </Styled.ProgressBarListItemTitleStack>
                    <Styled.ProgressBarListLinearProgress variant="determinate" value={Math.min(row.value, 100)} />
                </Styled.ProgressBarListItemBox>
            ))}
            {isLoading &&
                Array.from({ length: loadingRowsCount ?? 3 }, (_, index) => (
                    <Styled.ProgressBarListItemBox key={index}>
                        <Skeleton variant="text" width="100%" />
                        <Skeleton variant="text" width="100%" />
                    </Styled.ProgressBarListItemBox>
                ))}
        </Wrapper>
    );
};
